import { BaseLogger } from '../BaseLogger';
import { create } from '@wix/fedops-logger';

export class FedopsLogger extends BaseLogger {
  static fedopsLogger;
  constructor(appName) {
    super();
    FedopsLogger.fedopsLogger = create(appName);
  }

  appLoaded = () => {
    FedopsLogger.fedopsLogger.appLoaded();
  };
}
